<template>
  <div class="toolbar__group">
    <button aria-label="bold" class="toolbar__btn" type="button" @click="bold">
      <boldFont />
    </button>

    <button aria-label="underline" class="toolbar__btn" type="button" @click="italic">
      <italicFont />
    </button>

    <button aria-label="underline" class="toolbar__btn" type="button" @click="underline">
      <underlineFont />
    </button>
  </div>
</template>

<script>
import undoFormat from '../../../lib/undoFormat.js';
import boldFont from './icons/bold.svg';
import italicFont from './icons/italic.svg';
import underlineFont from './icons/underline.svg';
/**
 * Object to define and set attributes for each formatting option
 * attribute: value of data-format attribute used in <span>
 * nodeName: DOM node name for a formatting option
 * createNode: function to create the formatted text node
 */
const FORMAT_DETAILS = {
  bold: {
    attribute: 'bold',
    nodeName: 'B',
    createNode: (text = null) => {
      let bold = document.createElement('B');
      bold.setAttribute('data-format', 'bold');
      if (text) bold.appendChild(document.createTextNode(text));
      return bold;
    },
  },
  italic: {
    attribute: 'italic',
    nodeName: 'I',
    createNode: (text = null) => {
      let italic = document.createElement('I');
      italic.setAttribute('data-format', 'italic');
      if (text) italic.appendChild(document.createTextNode(text));
      return italic;
    },
  },
  underline: {
    attribute: 'underline',
    nodeName: 'SPAN',
    createNode: (text) => {
      const underline = document.createElement('span');
      underline.style.textDecoration = 'underline';
      underline.setAttribute('data-format', 'underline');
      if (text) underline.appendChild(document.createTextNode(text));
      return underline;
    },
  },
};

export default {
  name: 'Formatting',
  components: {
    boldFont,
    italicFont,
    underlineFont,
  },
  props: {
    selected: {
      type: Range,
      default: () => new Range(),
    },
  },
  methods: {
    bold() {
      if (this.selected.toString().length === 0) return;
      let undo = undoFormat(this.selected, FORMAT_DETAILS.bold);
      if (!undo) {
        let bold = FORMAT_DETAILS['bold'].createNode();
        this.selected.surroundContents(bold);
      }
      this.$emit('toolbar-action', 'bold');
      this.dispatchInputEvent();
    },
    italic() {
      if (this.selected.toString().length === 0) return;
      let undo = undoFormat(this.selected, FORMAT_DETAILS.italic);
      if (!undo) {
        let italic = FORMAT_DETAILS['italic'].createNode();
        this.selected.surroundContents(italic);
      }
      this.$emit('toolbar-action', 'italic');
      this.dispatchInputEvent();
    },
    underline() {
      if (this.selected.toString().length === 0) return;
      let undo = undoFormat(this.selected, FORMAT_DETAILS.underline);
      if (!undo) {
        let underline = FORMAT_DETAILS['underline'].createNode();
        this.selected.surroundContents(underline);
      }
      this.$emit('toolbar-action', 'underline');
      this.dispatchInputEvent();
    },
    dispatchInputEvent() {
      this.selected.commonAncestorContainer.dispatchEvent(new Event('input', { bubbles: true }));
    },
  },
};
</script>
